define([
    "dojo/_base/lang",
    "../../../constants/TypeConstants",
    "../properties/TypeProperty",
    "../properties/TagProperty",
    "../properties/EnabledProperty",
    "../properties/DescriptionProperty",
    "../properties/DescriptionOverrideProperty",
    "../properties/MnemonicProperty",
    "../properties/ShortcutProperty",
    "../properties/ActionIdProperty",
    "../properties/TextProperty",
    "../properties/ItemsProperty",
    "../properties/PlaceholderTextProperty",
    "../properties/ErrorTextProperty",
    "../properties/WarningTextProperty",
    "../properties/ValidationStateProperty"

],
    function (lang, TypeConstants, TypeProperty, TagProperty, EnabledProperty, DescriptionProperty, DescriptionOverrideProperty, MnemonicProperty, ShortcutProperty, ActionIdProperty, TextProperty, ItemsProperty, PlaceHolderTextProperty, ErrorTextProperty, WarningTextProperty, ValidationStateProperty) {
        var hash = {};

        hash[TypeConstants.COMBO_BOX] = lang.mixin({}, {
            selectedItem: {
                type: "string",
                defaultValue: "",
                notInAction: false,
                required: false
            },
             editable: {
                    type: "boolean",
                    notInAction: false,
                    defaultValue: false,
                    required: false
             },
            footerId: {
                type: "string",
                notInAction: true,
                required: false,
                defaultValue: ""
            }
        }, TypeProperty, TagProperty, EnabledProperty,
            DescriptionProperty, DescriptionOverrideProperty, MnemonicProperty, ShortcutProperty, ActionIdProperty,
            TextProperty, ItemsProperty, PlaceHolderTextProperty, ErrorTextProperty, WarningTextProperty, ValidationStateProperty
        );

        return hash;
    });

